import ContentLoader from 'react-content-loader';

interface IMenuBarSkeletonProps {
  /** Quantidade de itens exibidos no skeleton. */
  items?: number;
}

/**
 * Skeleton exibido no lugar dos itens do menu do header enquanto a fonte de
 * ícones (Material Symbols) e os dados do usuário ainda não carregaram,
 * evitando o flash com o nome cru dos ícones (ex.: "ads_click").
 */
function MenuBarSkeleton({ items = 6 }: IMenuBarSkeletonProps) {
  const roundedProps = { rx: 6, ry: 6 };
  const itemWidth = 96;
  const gap = 24;
  const width = items * itemWidth + (items - 1) * gap;
  const height = 24;

  return (
    <ContentLoader
      speed={2}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor='#e0e0e0'
      foregroundColor='#f5f5f5'
      aria-label='Carregando menu'
    >
      {Array.from({ length: items }).map((_, index) => (
        <rect
          key={index}
          x={index * (itemWidth + gap)}
          y={2}
          width={itemWidth}
          height={height - 4}
          {...roundedProps}
        />
      ))}
    </ContentLoader>
  );
}

interface IMenuBarIconsSkeletonProps {
  /** Quantidade de ícones circulares exibidos. */
  count?: number;
  /** Diâmetro de cada ícone em px. */
  size?: number;
}

/**
 * Skeleton dos botões de ícone (circulares) do header — usado para search,
 * notificações e menu lateral enquanto a fonte de ícones ainda não carregou.
 */
function MenuBarIconsSkeleton({ count = 3, size = 40 }: IMenuBarIconsSkeletonProps) {
  const gap = 8;
  const width = count * size + (count - 1) * gap;

  return (
    <ContentLoader
      speed={2}
      width={width}
      height={size}
      viewBox={`0 0 ${width} ${size}`}
      backgroundColor='#e0e0e0'
      foregroundColor='#f5f5f5'
      aria-label='Carregando menu'
    >
      {Array.from({ length: count }).map((_, index) => (
        <circle
          key={index}
          cx={index * (size + gap) + size / 2}
          cy={size / 2}
          r={size / 2}
        />
      ))}
    </ContentLoader>
  );
}

export { MenuBarSkeleton, MenuBarIconsSkeleton };
